// Webpack DefinePlugin in this project replaces only direct references
// (e.g. process.env.REACT_APP_SENTRY_DSN), not dynamic property access.
const envMap = {
  REACT_APP_ENV: process.env.REACT_APP_ENV,
  REACT_APP_SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
  REACT_APP_ENABLE_SENTRY: process.env.REACT_APP_ENABLE_SENTRY,
  REACT_APP_SENTRY_TRACES_SAMPLE_RATE:
    process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE,
  REACT_APP_SENTRY_PROFILES_SAMPLE_RATE:
    process.env.REACT_APP_SENTRY_PROFILES_SAMPLE_RATE,
  REACT_APP_SENTRY_SAMPLE_RATE: process.env.REACT_APP_SENTRY_SAMPLE_RATE,
  REACT_APP_SENTRY_DEBUG: process.env.REACT_APP_SENTRY_DEBUG,
  REACT_APP_SENTRY_MAX_BREADCRUMBS:
    process.env.REACT_APP_SENTRY_MAX_BREADCRUMBS,
  REACT_APP_SENTRY_SEND_DEFAULT_PII:
    process.env.REACT_APP_SENTRY_SEND_DEFAULT_PII,
  REACT_APP_SENTRY_ENABLE_TRACING: process.env.REACT_APP_SENTRY_ENABLE_TRACING,
  REACT_APP_SENTRY_SHUTDOWN_TIMEOUT: process.env.REACT_APP_SENTRY_SHUTDOWN_TIMEOUT,
  REACT_APP_SENTRY_ATTACH_STACKTRACE: process.env.REACT_APP_SENTRY_ATTACH_STACKTRACE,
  REACT_APP_SENTRY_IGNORE_ERRORS: process.env.REACT_APP_SENTRY_IGNORE_ERRORS,
}

export const getEnv = (key) => envMap[`REACT_APP_${key}`] ?? envMap[key]
